import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconSubscriptionExpireClock: React.FC<IconProps> = ({ width = 72, height = 72 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width={width} height={height} rx="36" fill="#EDFFF3" />
            <path
                d="M19.3327 35.9987C19.3327 45.2034 26.7946 52.6654 35.9993 52.6654C45.2041 52.6654 52.666 45.2034 52.666 35.9987C52.666 26.794 45.2041 19.332 35.9993 19.332"
                stroke="#FF1A1A"
                stroke-width="3"
                stroke-linecap="round"
            />
            <path
                d="M36 31V37.6667H42.6667"
                stroke="#FF1A1A"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <circle
                cx="36.0006"
                cy="35.9987"
                r="16.6667"
                stroke="#FF1A1A"
                stroke-width="3"
                stroke-linecap="round"
                stroke-dasharray="1.5 5"
            />
        </svg>
    );
};

export default IconSubscriptionExpireClock;
